import styles from "../../style.module.scss";
import useStore from "../../store/store";
import {useState} from "react";
import formatPrice from "../../utils/format-price";
import {getInsuranceName, getInsuranceRule} from "../../utils/service-text";

function Step3({number, insurances, links}) {
    const [open, setOpen] = useState(false);
    const ratesHide = useStore((state) => state.ratesHide)
    const currentInsurance = useStore((state) => state.currentInsurance)
    const setCurrentInsurance = useStore((state) => state.setCurrentInsurance)
    const lang = useStore((state) => state.lang)

    const t = {
        liabilityReductionPackage: lang === 'en' ? 'Select a liability reduction package' : 'Выберите пакет снижения ответственности',
        withoutReduction: lang === 'en' ? 'Without liability reduction' : 'Без снижения ответственности',
        showMore: lang === 'en' ? 'Show more' : 'Смотреть подробнее',
        perDay: lang === 'en' ? '/day' : '/сут'
    };

    const getCurrentValue = () => {
        if (currentInsurance) {
            const insurance = insurances.filter((insurance) => insurance.caraddonid === currentInsurance);
            if (insurance && insurance[0]) {
                return getInsuranceName(insurance[0], lang);
            }
        }
        return t.withoutReduction;
    }
    if (!insurances) {
        return null;
    }

    return (<div className={styles.newOrder__step}>
        <div className={`${styles.newOrder__stepHead} p-size`} onClick={() => setOpen(!open)}>
            <div className={styles.newOrder__stepNumber}>
                {ratesHide ? number - 1 : number}
            </div>
            {t.liabilityReductionPackage}
            <div className={styles.newOrder__stepValue}>{getCurrentValue()}</div>
            <div className={`${styles.newOrder__stepStatus} ${open && styles.open}`}/>
        </div>
        {
            !!open && (
                <div className={styles.newOrder__stepContent}>
                    <div className={styles.insurances}>
                        <div className={styles.insurance} onClick={() => setCurrentInsurance(null)}>
                            <div className={`${styles.checkbox} ${!currentInsurance && styles.checked}`}/>
                            <span className='p-size'>{t.withoutReduction}</span>
                        </div>
                        {
                            insurances.map((item) => {
                                const insuranceName = getInsuranceName(item, lang);
                                const insuranceRule = getInsuranceRule(item, lang);

                                return (<div key={item.caraddonid} className={styles.insurance}
                                             onClick={() => setCurrentInsurance(item.caraddonid)}>
                                    <div
                                        className={`${styles.checkbox} ${currentInsurance === item.caraddonid && styles.checked}`}/>
                                    <div className={`${styles.heading} p-size`}>
                                        {insuranceName}
                                        {!!insuranceRule && (<span className={`${styles.description}`}>{insuranceRule}</span>)}
                                        {
                                            !!item.caraddonprice && (<span>{formatPrice(item.caraddonprice, t.perDay)}</span>)
                                        }
                                    </div>

                                </div>)
                            })
                        }
                    </div>
                    {
                        !!links?.insurance?.link && (
                            <a href={links.insurance.link} className={styles.moreButton} target='_blank' rel='noreferrer'>
                                {t.showMore}
                            </a>)
                    }

                </div>
            )
        }

    </div>);
}

export default Step3;